'use client';

import {
  legacySimulatorSection,
  legacySimulatorStep
} from '@stereoagency/sanity-schema';
import { LegacySimulatorSection as UILegacySimulatorSection } from '@stereoagency/ui';
import useTranslation from 'next-translate/useTranslation';
import { SimpleBlockContent } from '../sanity/client';
import { sanityImageAsProps } from '@/utils';
import { InputSchema } from '@/app/(root)/api/email/route';

type Props = typeof legacySimulatorSection.schema.legacySimulatorSection;
type Step = typeof legacySimulatorStep.schema.legacySimulatorStep;

const convertDataStep = (step: Step) => {
  if (!step)
    return {
      icon: undefined,
      title: '',
      description: <SimpleBlockContent value={[]} />
    };
  return {
    icon: step?.icon?.asset?._ref ? sanityImageAsProps(step.icon) : undefined,
    title: step.title,
    description: <SimpleBlockContent value={step.description || []} />
  };
};

export default function LegacySimulatorSection({
  step1,
  step2,
  step3,
  step4
}: Props) {
  const { t } = useTranslation('legacy-simulator');

  const handleSendEmail = async ({
    email,
    subject,
    content
  }: {
    email: string;
    subject: string;
    content: string;
  }) => {
    const url = new URL('/api/email', window.location.href);
    const body: InputSchema = {
      email,
      templateId: '3',
      subject,
      params: {
        contact: {
          text: t('contact'),
          link: 'mailto:legs@deduveinstitute.be'
        },
        content
      }
    };
    await fetch(url.toString(), {
      method: 'POST',
      body: JSON.stringify(body),
      headers: [['Content-Type', 'application/json']]
    });
  };

  return (
    <UILegacySimulatorSection
      data={{
        step1: convertDataStep(step1 as Step),
        step2: convertDataStep(step2 as Step),
        step3: convertDataStep(step3 as Step),
        step4: convertDataStep(step4 as Step)
      }}
      t={t}
      handleSendEmail={handleSendEmail}
    />
  );
}
